import List from './List.tsx';
export type { ListProps } from './List.types';

export default List;
